/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCatalogItemDto
 */
export interface UpdateCatalogItemDto {
    /**
     * Price for this product in the catalog
     * @type {number}
     * @memberof UpdateCatalogItemDto
     */
    price?: number;
    /**
     * Currency for the price
     * @type {string}
     * @memberof UpdateCatalogItemDto
     */
    currency?: UpdateCatalogItemDtoCurrencyEnum;
    /**
     * Minimum order quantity
     * @type {number}
     * @memberof UpdateCatalogItemDto
     */
    minimumOrderQty?: number;
    /**
     * Maximum order quantity
     * @type {number}
     * @memberof UpdateCatalogItemDto
     */
    maximumOrderQty?: number;
    /**
     * Whether the product is in stock
     * @type {boolean}
     * @memberof UpdateCatalogItemDto
     */
    inStock?: boolean;
    /**
     * Stock quantity available (null = unlimited, 0 = out of stock)
     * @type {number}
     * @memberof UpdateCatalogItemDto
     */
    stockQuantity?: number;
    /**
     * Description of the catalog item
     * @type {string}
     * @memberof UpdateCatalogItemDto
     */
    description?: string;
    /**
     * Lead time for the product in days
     * @type {number}
     * @memberof UpdateCatalogItemDto
     */
    leadTime?: number;
    /**
     * Time-based order limit (DAY, WEEK, or MONTH)
     * @type {object}
     * @memberof UpdateCatalogItemDto
     */
    orderLimit?: object;
}


/**
 * @export
 */
export const UpdateCatalogItemDtoCurrencyEnum = {
    Egp: 'EGP',
    Sar: 'SAR',
    Mad: 'MAD'
} as const;
export type UpdateCatalogItemDtoCurrencyEnum = typeof UpdateCatalogItemDtoCurrencyEnum[keyof typeof UpdateCatalogItemDtoCurrencyEnum];


/**
 * Check if a given object implements the UpdateCatalogItemDto interface.
 */
export function instanceOfUpdateCatalogItemDto(value: object): value is UpdateCatalogItemDto {
    return true;
}

export function UpdateCatalogItemDtoFromJSON(json: any): UpdateCatalogItemDto {
    return UpdateCatalogItemDtoFromJSONTyped(json, false);
}

export function UpdateCatalogItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCatalogItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'price': json['price'] == null ? undefined : json['price'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'minimumOrderQty': json['minimumOrderQty'] == null ? undefined : json['minimumOrderQty'],
        'maximumOrderQty': json['maximumOrderQty'] == null ? undefined : json['maximumOrderQty'],
        'inStock': json['inStock'] == null ? undefined : json['inStock'],
        'stockQuantity': json['stockQuantity'] == null ? undefined : json['stockQuantity'],
        'description': json['description'] == null ? undefined : json['description'],
        'leadTime': json['leadTime'] == null ? undefined : json['leadTime'],
        'orderLimit': json['orderLimit'] == null ? undefined : json['orderLimit'],
    };
}

export function UpdateCatalogItemDtoToJSON(value?: UpdateCatalogItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'price': value['price'],
        'currency': value['currency'],
        'minimumOrderQty': value['minimumOrderQty'],
        'maximumOrderQty': value['maximumOrderQty'],
        'inStock': value['inStock'],
        'stockQuantity': value['stockQuantity'],
        'description': value['description'],
        'leadTime': value['leadTime'],
        'orderLimit': value['orderLimit'],
    };
}

